<template>
  <b-container tag="article" data-aos="fade-up">
    <b-img-lazy
      class="w-100"
      alt="Picture of a group of people stood around a BBQ"
      src="../../../assets/news/contact-thaw.jpg"
    />
    <h1 class="text-primary mt-5 mb-2">Drivers Get Together</h1>
    <h2 class="text-info mb-2">Oct 24, 2017</h2>
    <p>
      <i>
        Being a volunteer driver can be good fun! Meeting people from your own
        and other villages has been great!
      </i>
    </p>
    <p>
      Occasionally drivers choose to meet up socially together to get to know
      each other a little better. We had a barbecue in Thorney back in early
      September with everyone contributing salads and desserts to go with the
      barbecued food and despite some drizzly rain a good time was had by all.
      Our next get together will be a Christmas Lunch at the White Hart at North
      Scarle in early December where drivers are getting together with some of
      our most regular passengers to enjoy good company and a great meal to get
      us in the festive mood!
    </p>
  </b-container>
</template>

<script>
export default {
  name: "DriversGetTogether",
};
</script>
